var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPen = function SvgEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12.916.085c-.748 0-1.495.284-2.062.85L9.262 2.529a.6.6 0 0 0-.147.146L1.63 10.158a1.46 1.46 0 0 0-.371.631L.024 15.118a.625.625 0 0 0 .772.772l4.33-1.236a1.46 1.46 0 0 0 .63-.371l7.469-7.469a.6.6 0 0 0 .175-.176l1.578-1.578a2.926 2.926 0 0 0 0-4.124 2.9 2.9 0 0 0-2.062-.85m0 1.243c.425 0 .85.164 1.178.492.657.656.657 1.7 0 2.356L12.87 5.401l-2.357-2.357 1.225-1.224a1.66 1.66 0 0 1 1.178-.492m-3.287 2.6 2.357 2.357-7.114 7.114a.2.2 0 0 1-.09.053l-.41.117-2.027-2.026.117-.411a.2.2 0 0 1 .053-.09zm-7.677 8.99 1.045 1.044-1.463.418z"
  })));
};
export default SvgEditPen;